import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import axios from 'utils/axios';
import { errorMessageGenerator, creator } from 'uwork-app-core';

/**
 * Constants
 */
export const REQUEST = '@app/dashoard/REQUEST';
export const SUCCESS = '@app/dashoard/SUCCESS';
export const FAILURE = '@app/dashoard/FAILURE';

/**
 * Initial state
 */
const initState = {
    data: {},
    dataLoading: false
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.dataLoading = true;
                break;
            case SUCCESS:
                draft.data = payload;
                draft.dataLoading = false;
                break;
            case FAILURE:
                draft.dataLoading = false;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: () => creator(REQUEST),
    failure: () => creator(FAILURE),
    success: (data) => creator(SUCCESS, data)
};

/**
 * Sagas
 */
export const sagas = {
    *request() {
        try {
            const response = yield axios.get('/stats');
            yield put(actions.success(response.data));
        } catch (e) {
            console.error(errorMessageGenerator(e));
            yield put(actions.failure());
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
